import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { applyTheme, getInitialTheme } from "./utils/theme";

// Apply the saved/system theme before first paint to avoid a flash.
applyTheme(getInitialTheme());
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-789" data-mp="2677lz4v422pi" />);
}